import { render, staticRenderFns } from "./live-broadcast.vue?vue&type=template&id=380f75e0&scoped=true&"
import script from "./live-broadcast.vue?vue&type=script&lang=js&"
export * from "./live-broadcast.vue?vue&type=script&lang=js&"
import style0 from "./live-broadcast.vue?vue&type=style&index=0&id=380f75e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f75e0",
  null
  
)

export default component.exports